import { render, staticRenderFns } from "./SKU.vue?vue&type=template&id=dcd658c6&"
import script from "./SKU.vue?vue&type=script&lang=ts&"
export * from "./SKU.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports